






































































import { Component, Watch, Ref } from "vue-property-decorator";

import Header from "@/components/header/ULoginHeader.vue";
import ImageModal from "@/components/ImageModal.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";
import ConversationsApi from "@/services/Conversations";
import UgcsApi from "@/services/Ugcs";
import OrganizationApi from "@/services/Organizations";
import MessagesApi from "@/services/Messages";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import AuthModule from "@/store/auth";
import { io } from "socket.io-client";
import { Message, NewConversations, NewMessages, SortDirection, UGC, User } from "@/api/lab-base-api-client";
import { VueConstructor } from "vue";
import axios from "axios";
import logger from "@/lib/log/logger";
import fileDownload from "js-file-download";

@Component({
  components: {
    Header,
    ImageModal,
  },
})
export default class UChat extends CheckUserLogin {
  @Ref()
  private textarea: VueConstructor | undefined;

  private messages: Message[] = [];

  private UGC: UGC[] = [];

  private file: File | null = null;

  private textareaHeight: undefined | string = "60px";

  private textareaRow = 1;

  private adminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";

  private conversationUuid = "";

  // 表示メッセージ件数 初期値：30
  private viewMessageNum = 30;

  private conversationForm: NewConversations = {
    userUuid: "",
    adminUuid: "",
  };

  private messageForm: NewMessages = {
    conversationUuid: "",
    senderUuid: "",
    text: "",
  };

  private isChatImgModal = false;

  private src: string | null = null;

  // 有料ユーザー
  private get isAllowAccess() {
    return AuthModule.me?.paidFlag;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private async mounted() {
    if (!this.isAllowAccess) {
      this.$router.push({ name: "UDashboard" });
      return;
    }
    this.socket.on("sendConversationUuid", () => {
      if (this.$route.name === "UChat") {
        this.fetchMessages(this.conversationUuid);
        this.read();
      }
    });

    this.checkOrganizationExpiration();
    this.resize();
    await this.fetch();
    await this.attachDownload();
    this.attachClickEvent();
  }

  // 画像モーダルの表示
  private async openImgModal(event: Event) {
    if (!event) {
      return;
    }
    this.isChatImgModal = true;
    this.src = (event?.target as HTMLImageElement).src;
  }

  // organizationUser契約期限のチェック
  private async checkOrganizationExpiration() {
    if (!this.me || this.me.roleId !== 4) {
      return;
    }
    await OrganizationUsersApi.instance.checkExpirationDate(this.me.uuid);
  }

  private async fetch() {
    if (this.me) {
      const conversationsRes = await ConversationsApi.instance.getConversationByUserUuid(this.me.uuid);
      const conversation = conversationsRes.data.data.items;

      if (conversation.length > 0) {
        this.conversationUuid = conversation[0].uuid;
        this.messageForm.conversationUuid = this.conversationUuid;
        await this.fetchMessages(this.conversationUuid).then(() => {
          if (this.messages.length > 0) {
            this.displayLatestChat();
            this.read();
          }
        });
      } else {
        this.conversationForm.userUuid = this.me.uuid;
        this.conversationForm.adminUuid = this.adminUuid;

        if (this.me.roleId === 4 && "organizationUuid" in this.me) {
          this.conversationForm.organizationUuid = this.me.organizationUuid;
        }

        const createConversationRes = await ConversationsApi.instance.createConversations(this.conversationForm);
        if (createConversationRes.data.data.conversation) {
          this.conversationUuid = createConversationRes.data.data.conversation.uuid;
        }
      }
    }
  }

  // メッセージの取得
  private async fetchMessages(conversationUuid: string) {
    const messagesRes = await MessagesApi.instance.getMessage(
      conversationUuid,
      this.viewMessageNum,
      undefined,
      SortDirection.Desc
    );
    const messages = messagesRes.data.data.items;
    messages.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return 1;
      }
      return -1;
    });
    this.messages = messages;
  }

  // 既読
  private async read() {
    if (!this.me) {
      return;
    }

    try {
      await MessagesApi.instance.patchReadFlag(this.me.uuid, this.conversationUuid);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  private socket = io(
    `${process.env?.NODE_ENV === "development" ? "http://localhost:3000" : process.env.VUE_APP_SOCKET_URL}`,
    {
      withCredentials: true,
      path: `${process.env?.NODE_ENV === "development" ? "" : "/api/socket.io"}`,
    }
  );

  private async submit() {
    // 送信処理
    if (!this.me) {
      return;
    }
    this.messageForm.senderUuid = this.me.uuid;

    // text内のlinkを検出し変換
    const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    const regexpMakeLink = (url: string) => {
      return `<a class="link" href="${url}">${url}</a>`;
    };

    this.messageForm.text = this.messageForm.text.replace(regexpUrl, regexpMakeLink);

    // UGCが一つ以上ある場合ugcTypeを検証し適した形に変換
    if (this.UGC.length > 0) {
      let files = "";
      for (let i = 0; i < this.UGC.length; i += 1) {
        if (this.UGC[i].ugcType === "image") {
          files += `<img src="${this.UGC[i].url}" class="chat-img">`;
        } else if (this.UGC[i].ugcType === "zip") {
          files += `<div class="file-wrap download" data-ugc-uuid="${this.UGC[i].uuid}"><i class="v-icon file-icon fa fa-solid fa-file-download"></i><div class="file-name">${this.UGC[i].metadata.originalname}</div></div>`;
        }
      }

      if (this.messageForm.text) {
        this.messageForm.text += `<div class="files mt-3">${files}</div>`;
      } else {
        this.messageForm.text += `<div class="files">${files}</div>`;
      }
      await MessagesApi.instance.postMessage(this.messageForm);

      this.UGC = await [];
    } else if (this.messageForm.text !== "") {
      await MessagesApi.instance.postMessage(this.messageForm);
    }

    this.socket.emit("sendMessage", this.conversationUuid);
    this.messageForm.text = "";
    await this.fetchMessages(this.conversationUuid);
    this.displayLatestChat();
    this.submitSlackNotice(this.me);
  }

  // UGCの中身から対応した情報を削除することでUGCモーダルのclose機能を実装
  private async closeUgcModal(i: number) {
    this.UGC.splice(i, 1);
    if (this.file) {
      this.file = null;
    }
  }

  private async postUGC() {
    if (this.file) {
      const ugc = await this.createUgc(this.file);
      this.UGC.push(ugc);
      this.file = null;
    }
  }

  // messagesの中身が変わるごとにchat上のUGCファイルにダウンロード機能を付与
  @Watch("messages")
  private async attachDownload() {
    const downloadBtns = document.querySelectorAll(".download");
    if (downloadBtns.length > 0) {
      downloadBtns.forEach((elem: Element) => {
        elem.addEventListener("click", this.download);
      });
    }
  }

  // 画像モーダル表示機能を有効にするためのクリックイベントの付与
  @Watch("messages")
  private attachClickEvent() {
    const imgElements = document.querySelectorAll(".chat-img");
    if (imgElements.length > 0) {
      imgElements.forEach(elem => {
        elem.addEventListener("click", this.openImgModal);
      });
    }
  }

  // UGCダウンロード機能
  private async download(e: Event) {
    try {
      const element = e.currentTarget as HTMLInputElement;
      const targetUuid = element.dataset.ugcUuid;
      const ugcData = await UgcsApi.instance.getUGC(targetUuid as string);
      const ugcRes = await UgcsApi.instance.getDownloadUGC(targetUuid as string, { responseType: "blob" });
      fileDownload(ugcRes.data, ugcData.data.data.ugc.metadata.originalname);
    } catch (err) {
      console.log(err);
    }
  }

  // slackへ通知
  private async submitSlackNotice(user: User) {
    let text = "";

    if (this.me && this.me.roleId === 4 && "organizationUuid" in this.me) {
      const organizationRes = await OrganizationApi.instance.getOrganizationsByUuid(this.me.organizationUuid);
      const { organization } = organizationRes.data.data;
      text = `${user.name}さん（${organization.name}）からメッセージが送信されました`;
    } else {
      text = `${user.name}さんからメッセージが送信されました`;
    }
    const channel = process.env.NODE_ENV === "production" ? "#チャット通知" : "#notice-dev";
    const params = new URLSearchParams();
    params.append("token", "xoxb-3051803435092-3476235718992-NViZmlLmPhPeVVLjJy1mD7lc");
    params.append("channel", channel);
    params.append("text", text);

    await axios.post("https://slack.com/api/chat.postMessage", params);
  }

  // UGC作成
  private async createUgc(file: File) {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(file);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      throw err;
    }
  }

  get style() {
    return { height: this.textareaHeight };
  }

  @Watch("messageForm.text", { deep: true })
  private changeTextareaRow() {
    this.resize();
  }

  /**
   * リサイズ
   */
  private async resize() {
    this.textareaRow = 1;
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const height = (this.$refs.textarea as any).$el.querySelector("textarea").scrollHeight;

      // 84 = テキストエリアの高さ、row3つ分
      // 3行分以上の高さの場合、3をtextareaRowに代入
      if (height >= 84) {
        this.textareaRow = 3;
      } else if (height > 32) {
        // 2行分の高さの場合、2をtextareaRowに代入
        this.textareaRow = 2;
      } else {
        // 1行分の高さの場合1をtextareaRowに代入
        this.textareaRow = 1;
      }
    });
  }

  // 最新のチャットを表示
  // chat一覧要素の下の位置をまで遷移させる
  private displayLatestChat() {
    if (this.$refs.inner) {
      (this.$refs.inner as Element).scrollIntoView(false);
    }
  }

  /**
   * urlが含まれている場合、リンクに変換してメッセージを表示
   */
  private displayMessage(message: string) {
    const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    const regexpMakeLink = (url: string) => {
      return `<a class="link" href="${url}">${url}</a>`;
    };

    return message.replace(regexpUrl, regexpMakeLink);
  }

  /**
   * chatContentScrollのscrollTopが0になるまでスクロールで、メッセージの取得件数を増やす
   * メッセージの追加読み込み時に表示位置を変更しない
   */
  private async onScroll() {
    const chatContentElement = this.$refs.chatContent as Element;
    /**
     * チャットを取得する前の要素の高さ
     * ここで高さを定義することでオブジェクトの参照によるコピーを回避し、値としてコピーする
     */
    const beforeChatContentScrollHeight = chatContentElement.scrollHeight;
    if (chatContentElement.scrollTop === 0) {
      this.viewMessageNum += 30;
      await this.fetchMessages(this.conversationUuid);
      // チャットを取得した後とチャットを取得する前の要素の高さの差
      const scrollHeightDiff = chatContentElement.scrollHeight - beforeChatContentScrollHeight;
      // メッセージの追加読み込み時に表示位置を変更しない
      chatContentElement.scrollTo(0, scrollHeightDiff);
    }
  }
}
